import * as React from 'jsx-dom';
import {unwrap} from 'core/helpers/dom';

interface BaseProps {
  text: string;
  classes?: string;
  iconVariation?: string;
  analytics?: Record<string, string | boolean>;
  attrs?: Record<string, string | boolean>;
}

interface FakeArrowLink extends BaseProps {
  semantic: 'none';
}

export interface ArrowLinkProps extends BaseProps {
  link: string;
  rel?: string;
  target?: string;
  semantic?: 'a';
}

export interface ButtonProps extends BaseProps {
  semantic: 'button';
  type?: 'button' | 'submit' | 'reset';
}

// TODO: Unify all ArrowLinks entities!
export function renderArrowLink(props: ArrowLinkProps): HTMLAnchorElement;
export function renderArrowLink(props: ButtonProps): HTMLButtonElement;
export function renderArrowLink(props: FakeArrowLink): HTMLDivElement;
export function renderArrowLink(props: ArrowLinkProps | ButtonProps | FakeArrowLink): HTMLAnchorElement | HTMLButtonElement | HTMLDivElement {
  const {semantic, classes} = props;
  const attrs = {...props.analytics, ...props.attrs};
  const words = (props.text || '').trim().split(' ');
  const lastWord = words.pop();
  const iconVariation = props.iconVariation || 'arrow';
  const iconClass = iconVariation === 'none' ? '' : `${iconVariation}-icon`;
  const prefix = words.length ? `${words.join(' ')} ` : '';
  const tail = iconClass
    ? (
      <span className="icon-wrapper">
        {lastWord}
        <div className={`icon ${iconClass}`}/>
      </span>
    )
    : lastWord;
  const content = <span className="link-text">{prefix}{tail}</span>;

  if (semantic === 'button') {
    return (
      <button type={props.type} className={`hpe-arrow-link no-js ${classes || ''}`} {...attrs}>
        {content}
      </button>) as HTMLButtonElement;
  }

  if (semantic === 'none') {
    return (
      <div className={`hpe-arrow-link no-js ${classes || ''}`} {...attrs}>
        {content}
      </div>) as HTMLDivElement;
  }

  const {link, target, rel} = props;
  return (
    <a className={`hpe-arrow-link no-js ${classes || ''}`}
       href={link} rel={rel} target={target} {...attrs}>
      {content}
    </a>
  ) as HTMLAnchorElement;
}

export const ArrowLink = renderArrowLink;

interface ArrowLinksElement extends HTMLElement {
  __arrowLastWord?: boolean;
}

export const processArrowLink = (el: ArrowLinksElement): void => {
  const a = unwrap(el);
  if (a && !a.__arrowLastWord) {
    const words: string[] = (a.textContent || '').trim().split(' ');
    const lastWord: string = words.pop();
    a.innerHTML = `${words.join(' ')} <span class="icon-wrapper">${lastWord}<div class="icon arrow-icon"></div></span>`;
    a.__arrowLastWord = true;
  }
};

export default {
  processArrowLink,
  initialize: () => Array.from(document.querySelectorAll('.hpe-arrow-link:not(.no-js, .landmark)')).forEach(processArrowLink)
};
